import { render, staticRenderFns } from "./MobileBanner.vue?vue&type=template&id=fec20e5c"
import script from "./MobileBanner.vue?vue&type=script&lang=js"
export * from "./MobileBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports